import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { SelectPaymentComponentView } from './SelectPaymentComponentView';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { WprAnchor } from '../../wpr-framework/component/controls/WprAnchor';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';

/**
 * 支払い選択コンポーネント
 */
class SelectPaymentComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new SelectPaymentComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>5</span></li>
								<li className="done"><span>6</span></li>
								<li className="now"><span>7</span>
									<p className="conf" id="step7">保険料のお支払い</p>
								</li>
								<li><span>8</span></li>
							</ul>
						</div>
					</div>
				</div>
				
				<main className="page-credit">
					<div className="top">
						<h1>保険料の<br />お支払方法を選択してください</h1>
					</div>
					<section className="sum">
						<h2 className="c-headline">合計保険料</h2>
						<dl>
							<dt>保険料（全員分）</dt>
							<dd>
								<WprSpan view={this.view} name="insuranceFee" converter="3桁カンマ"></WprSpan>円
							</dd>
						</dl>
					</section>
					<section className="payment">
						<h2 className="c-headline">お支払い方法を選択してください</h2>
						<div className="pay-content">
							<WprButton view={this.view} name="creditButton" className="c-button"><span>クレジットカードで支払う</span></WprButton>
							<WprButton view={this.view} name="paypayButton" className="c-button"><span>PayPayで支払う</span></WprButton>
						</div>
					</section>
					<div className="prev">
						<WprAnchor view={this.view} name="prev" className="c-btn-prev">
							<span>1つ前の画面に戻る</span>
						</WprAnchor>
					</div>
					<WprContainer view={this.view} mode="paypayButton">
						<div className="c-layer">
							<div className="box">
								<WprButton view={this.view} name="closeButton" className="close-button"></WprButton>
								<h1>PayPay支払い</h1>
								<p>※　当社と契約している決済事業者の決済サイトに進みます。支払手続きを完了させると同時に保険契約も完了となります。</p>
								<WprButton view={this.view} name="settlementButton" className="button">決済サイトへ進む</WprButton>
							</div>
						</div>
					</WprContainer>
				</main>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
	
}

export default withRouter(SelectPaymentComponent);